import React, { useState, useEffect } from "react";
import { Col, Modal, Row, Image } from "react-bootstrap";
import Card from "../../../components/card/AdminCard";
import { isPermited } from "../../../features/localStorage";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetLearningModule,
  selectLearningModule,
} from "../../../features/learning/learningModuleSlice";
import {
  GetCounsellorModule,
  selectCounsellorModule,
} from "../../../features/learning/CounsellorSlice";
import {
  GetInsertMaterial,
  selectInsertMaterial,
} from "../../../features/learning/insertMaterialSlice";
import Add from "../../../assets/images/ic-add.svg";
import Back from "../../../assets/images/ic-arrow-back.svg";
import icTitle from "../../../assets/images/ic-edit-modal.svg";
import EmptyRow from "../../../components/emptyRow/EmptyRow";
import ENGModalHeader from "../../../components/modal/ENGModalHeader";
import ENGModalBody from "../../../components/modal/ENGModalBody";
import { useForm } from "react-hook-form";
import { Form, InputGroup } from "react-bootstrap";
import Search from "../../../assets/images/search-line.svg";
import FileUpload from "../../../components/textField/FileUpload";
import Feedback from "../../../components/feedbackNote/Feedback";
import MultiSelectCompany from "../../../components/textField/MultiSelectCompany";
import {
  GetAllCompany,
  selectAllCompany,
} from "../../../features/company/companyListSlice";
// import { selectUserPermisionData } from "../../../features/rolebase/userPermissionSlice";
// import BuMultiSelectInput from "../../../components/textField/BuMultiSelect";
// import Multiselect from "multiselect-react-dropdown";
import Dropdown from "../../../components/dropdown/Dropdown";
import {
  GetCategoryList,
  GetCategoryListAsync,
} from "../../../features/learning/CategorySlice";
import { useParams } from "react-router-dom";

const title: String = "";
const title2: String = "Ethics Counsellor Learning Program";

// Messages
const required = "This field is required";
const pattern = "Please insert valid input";
// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
const LearningModulesDetails = () => {
  const params = useParams();
  const dispatch = useAppDispatch();

  const { categoryId }: any = params || "";

  //  Modal Code
  const [modalShow, setModalShow] = useState(false);
  const LearingModule = useAppSelector(selectLearningModule);
  const CounsellorModule = useAppSelector(selectCounsellorModule);
  const allCompany = useAppSelector(selectAllCompany);
  const handleClose = () => setModalShow(false);

  const [companyId, setCompanyId] = useState([]);
  const [buId, setBuId] = useState("");
  const [sectorId, setSectorId] = useState("");
  // const [comapnyList, setCompanyList] = useState<any>();

  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const isAdmin = localStorage.getItem("isAdmin");
  const isAdminList: any = isAdmin;

  const isAdminJson = JSON.parse(isAdminList);

  useEffect(() => {
    if(categoryId){
      setCategory(categoryId);
    }
  }, [categoryId]);

  useEffect(() => {
    const learningPayload = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    async function fetchLearningModuleData() {
      let sample = await dispatch(GetLearningModule(learningPayload));
    }

    const data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    async function fetchConsellerModuleData() {
      let sample = await dispatch(GetCounsellorModule(data));
    }
    fetchLearningModuleData();
    fetchConsellerModuleData();
  }, [companyId]);

  var searchParams: any;
  const handleShow = () => {
    setModalShow(true);
    if (isAdminJson === false) {
      // call non sso comapny with id
      const fetchCompany = async () => {
        await dispatch(
          GetAllCompany(
            (searchParams = { type: 2, id: userDetailsJson.companyId })
          )
        );
      };
      fetchCompany();
    } else {
      // call sso +non sso company
      const fetchAllComany = async () => {
        await dispatch(GetAllCompany((searchParams = { type: "", id: 0 })));
      };
      fetchAllComany();
    }
  };
  // useEffect(()=>{
  //   setCompanyList(allCompany)
  // },[comapnyList])
  // Modal Code end
  const fetchLearningModuleData = () => {
    var learningPayload = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    dispatch(GetLearningModule(learningPayload));

    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    dispatch(GetCounsellorModule(data));
  };
  const [searchData, setsearchData] = useState("");
  const searchItems = async (searchValue: any) => {
    await setsearchData(searchValue);
    var data = {
      keyword: searchData,
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };

    await dispatch(GetLearningModule(data));
    await dispatch(GetCounsellorModule(data));
  };
  const rowLearnArrayData = LearingModule?.slice(0, 4);
  const Learnlist: any = rowLearnArrayData;

  const rowConsellArrayData = CounsellorModule?.slice(0, 4);
  const consellList: any = rowConsellArrayData;

  const [titleFeild, setTitle] = useState("");
  const [file, setFile] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState<any>("");
  const [paste, setPaste] = useState("");

  const InsertMaterial = useAppSelector(selectInsertMaterial);

  const categoryList = useAppSelector(GetCategoryList);
  const [dataList, setDataList] = useState<any>([]);

  useEffect(() => {
    dispatch(GetCategoryListAsync());
  }, []);

  useEffect(() => {
    if (categoryList?.length > 0) {
      let list: any = [];
      // let categoryDropdown: any = [];
      categoryList?.map((val: any) => {
        let obj = {
          id: val?.id,
          name: val?.categoryName,
          title: val?.categoryName,
          description: val?.categoryDescription,
          externalUrl: `/learning/${val?.id}`,
        };
        list = [...list, obj];
      });
      setDataList([...list]);
    }
  }, [categoryList]);

  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    // event.preventDefault();
    var setBuid = buId.toString();
    var setSectorId = sectorId.toString();
    var setCompnayId = companyId.toString();
    var data = {
      moduleId: 1,
      title: titleFeild,
      description: description,
      mediaType: "Documents",
      materialPath: file,
      externalUrl: paste,
      moduleType: "Learning Modules",
      companyId: setCompnayId,
      status: 0,
      buid: setBuid,
      sectorId: setSectorId,
      materialCategory: category,
    };

    await dispatch(GetInsertMaterial(data));
    var getdata = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    dispatch(GetLearningModule(getdata));
    handleClose();
  };

  const categoryList1 = [
    {
      id: 1,
      name: "ABAC",
    },
    {
      id: 2,
      name: "COC elearning module",
    },
    {
      id: 3,
      name: "POSH induction",
    },
    {
      id: 4,
      name: "POSH refresher",
    },
  ];

  return (
    <>
      <Feedback pageName="Learning And Awarness" />
      <Row>
        <Col sm={12}>
          <a href="/learning">
            <span style={styles.backstyle}>
              <Image src={Back} />
              Back{" "}
            </span>
          </a>
        </Col>
      </Row>
      <EmptyRow />
      <Row>
        <Col sm={7}>
          <h4>Learning Modules</h4>
        </Col>
        <Col sm={1}>
          {isPermited(1, 2) && (
            <a onClick={handleShow}>
              {" "}
              <span style={styles.editstyle}>
                <Image src={Add} /> ADD
              </span>
            </a>
          )}
          <Modal
            show={modalShow}
            onHide={handleClose}
            backdrop="static"
            size="lg"
            keyboard={false}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              <ENGModalHeader icon={icTitle} title=" Add New Module " />
              <ENGModalBody
                contents={
                  <>
                    <Row style={styles.divWhite}>
                      <Col sm={12} className="desk">
                        <label htmlFor="Unit">
                          Category <span style={styles.star}> * </span>
                        </label>
                        <Dropdown
                          id="Category"
                          data={dataList}
                          value={category}
                          onchange={setCategory}
                        />
                      </Col>
                      <EmptyRow />
                      <Col lg={6}>
                        <div className="floating-label-group">
                          <input
                            type="text"
                            name="title"
                            ref={register({
                              required: true,
                              pattern: /^[a-zA-Z0-9\s]*$/g,
                            })}
                            className="textstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setTitle(ev.target.value)}
                            // ref={register({ required: true})}
                          />
                          <label className="floating-label">
                            Title <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.title &&
                          errors.title.type === "required" &&
                          errorMessage(required)}
                        {errors.title &&
                          errors.title.type === "pattern" &&
                          errorMessage(pattern)}
                      </Col>
                      <Col lg={6}>
                        {/* <div className="floating-label-group">
                          <input
                            type="file"
                            id="File"
                            name={file}
                            
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setFile(ev.target.value)}
                            //ref={register({ required: true})}
                            className="textstyle"
                          />
                          <label className="floating-label">File <span style={styles.star}> * </span></label>
                        </div> */}
                        {/* {errors.file &&
                        errors.file.type === "required" &&
                        errorMessage(required)} */}
                        <FileUpload
                          setFile={setFile}
                          title="File"
                          fileValue=""
                          fileType="PDF"
                        />
                      </Col>
                    </Row>
                    <Row style={styles.divWhite}>
                      <Col lg={12} className="mb-4">
                        <div className="floating-label-group">
                          <input
                            type="text"
                            name="description"
                            ref={register({
                              required: true,
                              pattern: /^[a-zA-Z0-9\s]*$/g,
                            })}
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setDescription(ev.target.value)}
                            className="textstyle"
                          />
                          <label className="floating-label">
                            Description <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.description &&
                          errors.description.type === "required" &&
                          errorMessage(required)}
                        {errors.description &&
                          errors.description.type === "pattern" &&
                          errorMessage(pattern)}
                      </Col>

                      <Col lg={6} className="mt-4">
                        <div className="floating-label-group">
                          <input
                            type="text"
                            name="link"
                            ref={register({ required: true })}
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setPaste(ev.target.value)}
                            className="textstyle"
                          />
                          <label className="floating-label">
                            Paste URL <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.link &&
                          errors.link.type === "required" &&
                          errorMessage(required)}
                      </Col>
                      <Col lg={6} className="">
                        <label htmlFor="Unit">Accessible To</label>
                        <MultiSelectCompany
                          optionList={allCompany}
                          setId={setCompanyId}
                          selectedValue={""}
                          valueKey="id"
                          labelKey="company"
                          isAdd={true}
                        />
                      </Col>
                    </Row>
                  </>
                }
              />
              <EmptyRow />
              <EmptyRow />
              <Row style={styles.divGrey}>
                <Col sm={9}></Col>
                <Col sm={3}>
                  <button
                    type="button"
                    onClick={handleClose}
                    style={styles.button1}
                  >
                    {" "}
                    CANCEL{" "}
                  </button>
                  <button type="submit" style={styles.button}>
                    {" "}
                    SAVE{" "}
                  </button>
                </Col>
              </Row>
            </form>
          </Modal>
        </Col>

        {/* <Col sm={1}>
          {isPermited(1,3) &&
            <a href="/learningmodulesEditDetails">
              <span style={styles.editstyle}>
                <Image src={Edit} /> EDIT
              </span>
            </a>
          }
        </Col> */}
        <Col sm={4}>
          <InputGroup
            className="border bg-white"
            style={{ border: "solid 1px #e4e4e4" }}
          >
            <Image
              style={styles.image1}
              className="d-inline border-0 my-auto mx-2"
              src={Search}
              fluid
            />
            <Form.Control
              onChange={(e) => searchItems(e.target.value)}
              name={searchData}
              className="border-0 shadow-none ps-0"
              style={styles.text1}
              type="text"
              placeholder="Search"
            />
          </InputGroup>
        </Col>
      </Row>

      <EmptyRow />

      <div style={{ marginBottom: "20px" }}>
        <Card
          type={1}
          title={title}
          data={LearingModule}
          moduleid={1}
          fetchLearningModuleData={fetchLearningModuleData}
          modal={
            <>
              {/* <LearningModulesModal title="Learning Modules" records={LearingModule}/> */}
              {/* <LearningModulesEdit data={LearingModule}/> */}
            </>
          }
        />
      </div>
    </>
  );
};

const styles: any = {
  selectpoperty: {
    backgroundColor: "white",
    paddingBottom: "0px",
    border: "solid 1px #e4e4e4",
    width: "100%",
    fontFamily: "Saira",
    fontSize: "16px",
    color: "#6d6e71",
    borderRadius: "0px",
  },

  star: { color: "#e31837" },
  button: {
    padding: "13px 20px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
    color: "#fff",
    float: "right",
  },
  button1: {
    padding: "13px 20px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "500",
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#ffffff",
    border: "1px solid #e31837",
    letterSpacing: "normal",
    color: "#e31837",
  },
  divGrey: {
    backgroundColor: "rgb(250, 249, 249)",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
    paddingBottom: "20px",
    borderTop: "1px solid #eee;",
  },

  divWhite: {
    backgroundColor: "#ffffff",
    paddingTop: "20px",
    margin: "0px",
    paddingLeft: "10px",
    paddingRight: "10px",
  },

  cancel: {
    backgroundColor: "#ffffff",
    color: "#faf9f9",
    border: "1px solid #faf9f9",
  },

  editstyle: {
    color: "#e31837",
    fontFamily: "Saira",
    fontWeight: 600,
    fontSize: "12px",
    float: "right",
    marginTop: "10px",
  },

  backstyle: {
    color: "#e31837",
    fontFamily: "Saira",
    fontWeight: 600,
    fontSize: "12px",
    marginTop: "10px",
  },
};

export default LearningModulesDetails;
